import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore'
import 'firebase/compat/functions'
import 'firebase/compat/storage'
import * as Sentry from '@sentry/browser'

const Mutations = {
  setEnabledFields: 'setEnabledFields'
}

/**
 * generate default state for the module
 */
const getDefaultState = () => {
  return {
    enabledFields: []
  }
}

const state = getDefaultState()

const getters = {
  enabledFields: (_state) => {
    return _state.enabledFields
  }
}

const mutations = {
  [Mutations.setEnabledFields](_state, fields) {
    _state.enabledFields = fields
  }
}

const actions = {
  async fetchSettings(context, uid) {
    if (!uid) return

    try {
      const collectionRef = firebase.firestore().collection('card_content_settings')
      const querySnapshot = await collectionRef.where('uid', '==', uid).get()

      if (!querySnapshot.empty) {
        const doc = querySnapshot.docs[0]
        const data = doc.data()
        context.commit(Mutations.setEnabledFields, data.enabledFields || [])
        return data
      } else {
        console.log('No settings found for uid:', uid)
        context.commit(Mutations.setEnabledFields, [])
        return null
      }
    } catch (e) {
      console.error(e)
      Sentry?.captureException(e)
      return null
    }
  },

  async saveEnabledFields(context, payload) {
    if (!payload.uid) return

    try {
      context.commit(Mutations.setEnabledFields, payload.fields)

      const userUid = payload.uid
      const collectionRef = firebase.firestore().collection('card_content_settings')

      // Query to find existing document for the user
      const querySnapshot = await collectionRef.where('uid', '==', userUid).get()

      if (!querySnapshot.empty) {
        // Update the existing document
        const docRef = querySnapshot.docs[0].ref
        await docRef.update({
          enabledFields: payload.fields
        })
      } else {
        // Create a new document with auto-generated ID
        await collectionRef.add({
          enabledFields: payload.fields,
          uid: payload.uid
        })
      }

      return
    } catch (e) {
      console.error(e)
      Sentry?.captureException(e)
      return
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
  modules: {}
}
